import { Typography } from '@/components/UI/Typography'
import type { FC } from 'react'
import type { PointHistoryEntry } from './DialogPointHistory'
import { PointHistoryItem } from './PointHistoryItem'

type Props = {
  items: PointHistoryEntry[]
}

/**
 * ポイント履歴一覧コンポーネント。
 * 履歴がない場合は空メッセージを表示する。
 */
export const PointHistoryList: FC<Props> = ({ items }) => {
  if (items.length === 0) {
    return (
      <Typography variant="caption1" className="py-8 text-center" c="gray.5">
        データがありません
      </Typography>
    )
  }

  return (
    <ul>
      {items.map((item) => (
        <li key={item.id}>
          <PointHistoryItem label={item.label} point={item.point} acquiredAt={item.acquiredAt} />
        </li>
      ))}
    </ul>
  )
}
